import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-skeleton-box',
  components: {},
})
export default class SkeletonBox extends Vue {
  @Prop({ type: Number, default: 100 }) readonly maxWidth: number;
  @Prop({ type: Number, default: 50 }) readonly minWidth: number;
  @Prop({ type: String, default: '1em' }) readonly height: string;
  @Prop({ type: String, default: null }) readonly width: string;
  @Prop({ type: String, default: '5px' }) readonly borderRadius: string;
  @Prop({
    type: Object,
    default: () => {
      return {};
    },
  })
  readonly extraStyle: string;

  get computedWidth(): string {
    // Either use the given fixed width or
    // a random width between the given min
    // and max values.
    return (
      this.width ||
      `${Math.floor(Math.random() * (this.maxWidth - this.minWidth) + this.minWidth)}%`
    );
  }
}
